import { render } from "./SectionTransaction.vue?vue&type=template&id=0585c1fe"
import script from "./SectionTransaction.vue?vue&type=script&lang=js"
export * from "./SectionTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__